export const toAbsoluteUrl = (pathname: string): string => {
  if (!pathname) return ''
  if (pathname.startsWith('http')) return pathname

  const baseUrl =
    process.env.REACT_APP_BASE_URL ||
    (typeof window !== 'undefined' ? window.location.origin : '')

  return `${baseUrl}/${pathname.replace(/^\/+/, '')}`
}